import { array } from '@ember/helper';
import { t } from 'ember-intl';
import { tracked } from '@glimmer/tracking';
import Component from '@glimmer/component';
import TasCommentsContent, { AddCommentForm } from '../../comments/content.gts';
import type TasApplicationModel from 'tio-data/models/tas-application';
import type PersonModel from 'tio-data/models/person';
import type UserModel from 'tio-data/models/user';
import { DrawerHeader, DrawerBody, DrawerFooter } from 'tio-reimagined/components/drawer';

/**
 * Comments drawer content component
 * Wraps TasCommentsContent for application comments
 */
export interface CommentsDrawerSignature {
  Args: {
    model: TasApplicationModel;
    authoredByPerson: PersonModel;
    authoredByUser: UserModel;
    commentTags?: string[];
    initialTab?: 'approver' | 'employee';
  };
}

class CommentsDrawer extends Component<CommentsDrawerSignature> {
  @tracked activeTab: 'approver' | 'employee' = this.args.initialTab ?? 'approver';

  get commentTags() {
    return this.activeTab === 'approver' ? ['approver'] : ['Partner Messaging'];
  }

  handleTabChange = (tab: 'approver' | 'employee') => {
    this.activeTab = tab;
  };

  <template>
    <div class="tio-col-flush h-full">
      <DrawerHeader>
        <h2 class="tio-text-heading tio-fg-primary">{{t
            "tuition_assistance.application_approval.comments"
          }}</h2>
      </DrawerHeader>
      <DrawerBody>
        <TasCommentsContent
          @commentable={{@model}}
          @commentableType="TasApplication"
          @authoredByPerson={{@authoredByPerson}}
          @authoredByUser={{@authoredByUser}}
          @commentTags={{array "approver"}}
          @hideAddCommentForm={{true}}
          @initialTab={{@initialTab}}
          @onTabChange={{this.handleTabChange}}
        />
      </DrawerBody>
      <DrawerFooter>
        <AddCommentForm
          @commentable={{@model}}
          @commentableType="TasApplication"
          @authoredByPerson={{@authoredByPerson}}
          @commentTags={{this.commentTags}}
          @inDrawer={{true}}
        />
      </DrawerFooter>
    </div>
  </template>
}

export default CommentsDrawer;
